<p class="mt-1" *ngIf="show">
	<span [attr.class]="getTipo()" role="alert"> <i [attr.class]="getIcone()" aria-hidden="true"> </i>{{mensagem}}</span>
</p>
